import React from 'react'

export default props => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 2.00714L9.99286 1L6 4.99286L2.00714 1L1 2.00714L4.99286 6L1 9.99286L2.00714 11L6 7.00714L9.99286 11L11 9.99286L7.00714 6L11 2.00714Z"
      fill="#808080"
      stroke="#808080"
      strokeWidth="0.3"
    />
  </svg>
)
